import { forwardRef, useEffect } from "react";
import HintArrow from "./HintArrow";
import IntroText from "./IntroText";
import SkillsSphere from "./SkillsSphere";
import { useDispatch } from "react-redux";
import { setActiveSection } from "../../store";

function AboutSection({ preventIntersectionObserver }, ref) {
  const dispatch = useDispatch();

  /**
   * This is a callback to begin the observation of the div when the component first renders.
   */
  useEffect(() => {
    /**
     * An interaction observer object that allows us to monitor any interaction between the section's
     * div, and the viewport (visible area). It will make the section active when it intersects the
     * viewport.
     */
    const observer = new IntersectionObserver(
      (data) => {
        if (!preventIntersectionObserver.current && data[0].isIntersecting)
          dispatch(setActiveSection("about"));
      },
      {
        root: null,
        threshold: [0.55],
        rootMargin: "0px 5px 0px 0px",
      }
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, dispatch, preventIntersectionObserver]);

  return (
    <div className="h-full w-screen relative" ref={ref}>
      <IntroText className="absolute top-16 left-9" />
      <SkillsSphere diameter={250} className="absolute left-16 bottom-4" />
      <HintArrow className="absolute right-6 top-[45%]" />
    </div>
  );
}

export default forwardRef(AboutSection);
